import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/hivec-video-1.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};




const Prostate = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
 <h3>Преглед на простата</h3>
 
  <p>Добре дошли в Манхаймската урология, вашата надеждна частна урологична практика за профилактика и съвременно лечение на най-често срещаните урологични заболявания.</p>

<h2>Рак на простатата</h2>
<p>Ракът на простатата е вторият по честота рак при мъжете в световен мащаб, но ранното му откриване значително намалява усложненията и смъртността. Възрастта и семейната анамнеза са неконтролируеми рискови фактори, докато някои храни, инфекции и нездравословен начин на живот могат да бъдат избягвани, за да се намали рискът. За съжаление ракът на простатата в ранен стадий рядко проявява забележими симптоми, което прави откриването му трудно.</p>

<h2>Откриване в ранен стадий</h2>
<p>Нашият съвременен Стокхолм-3-тест, в допълнение към стандартния простатноспецифичен антиген (PSA) и палпацията на простатната жлеза, значително подобрява точността и надеждността за ранно откриване. Стокхолм-3-Тестът прави прецизно разграничение между агресивни и неагресивни тумори, като намалява ненужните биопсии с 50 % в сравнение със скрининга, базиран на PSA. Ако е необходимо, нашата поетапна диагностика включва изследване на простатата с ядрено-магнитен резонанс и биопсия по препоръка на рентгенолога.</p>

<h2>Варианти на лечение</h2>
<p>Нашата практика, в сътрудничество с други болници в района, предлага няколко ефективни възможности за лечение на рак на простатата, включително хирургично отстраняване, лъчетерапия и активно наблюдение. Хормонодепривативната терапия и лъчетерапията се предлагат като допълнителни възможности за лечение след операция.</p>

<h2>Приоритизиране на превантивните грижи</h2>
<p>В урологията на Манхайм даваме приоритет на превантивните грижи и съвременното лечение на урологичните заболявания. Нашият опитен екип е тук, за да подкрепи вашето урологично здраве и благополучие.</p>

 
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
 
                                <h3>Prostate check-up</h3>
                            <p>
  <p>Welcome to Mannheim Urologiy, your trusted private urology practice for the prevention and modern treatment of the most common urological diseases.</p>

<h2>Prostate Cancer</h2>
<p>Prostate cancer is the second most prevalent cancer in men worldwide, but early detection significantly reduces complications and mortality. Age and family history are uncontrollable risk factors, while certain foods, infections, and unhealthy lifestyles can be avoided to reduce risk. Unfortunately, early-stage prostate cancer rarely exhibits noticeable symptoms, making detection challenging.</p>

<h2>Early Detection</h2>
<p>Our state-of-the-art Stockholm-3-Test, in addition to standard prostate-specific antigen (PSA) and prostate gland palpation, dramatically improves accuracy and reliability for early detection. The Stockholm-3-Test distinguishes between aggressive and non-aggressive tumors with precision, reducing unnecessary biopsies by 50% compared to a PSA-based screening. If necessary, our staged diagnostics involve an MRI examination of the prostate and a biopsy, as recommended by the radiologist.</p>

<h2>Treatment Options</h2>
<p>Our practice in collaboration with other hospitals in the area, offers several effective treatment options for prostate cancer, including surgical removal, radiation therapy, and active surveillance. Hormone deprivation therapy and radiation therapy are available as additional treatment options after surgery.</p>

<h2>Prioritizing Preventive Care</h2>
<p>At Mannheim Urologiy, we prioritize preventive care and modern treatments for urological diseases. Our experienced team is here to support your urological health and wellbeing.</p>

                                <hr/>
 
                            </p>
 
                    </div>
                </section>
            )
    }


}

export default Prostate



// WEBPACK FOOTER //
// ./src/Components/Prostate.js